/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ApolloProvider } from '@apollo/client';
import { Provider as ReduxProvider } from 'react-redux';
import { Router } from 'react-router';
import { compose } from 'recompose';
import { StylesProvider, createGenerateClassName } from '@material-ui/styles';
// import StyleContext from 'isomorphic-style-loader/StyleContext';

import Account from './app/pages/Account/Account';
import AppShell from './app/pages/Account/AppShell/AppShell';
import { trackApp } from './app/helpers/tracking/common/commonTrackingHelpers';

const generateClassName = createGenerateClassName({
    productionPrefix: 'mbp-account',
});

const queryClient = new QueryClient();

const AccountApp = ({
    apolloClient,
    store,
    history,
    isUsingMFE,
}) => {
    if (apolloClient && store && history) {
        return (
            <QueryClientProvider client={queryClient}>
                <ApolloProvider client={apolloClient}>
                    <ReduxProvider store={store}>
                        <Router history={history}>
                            <StylesProvider generateClassName={generateClassName}>
                                {/* <StyleContext.Provider> */}
                                    <AppShell>
                                        <Account isUsingMFE={isUsingMFE} />
                                    </AppShell>
                                {/* </StyleContext.Provider> */}
                            </StylesProvider>
                        </Router>
                    </ReduxProvider>
                </ApolloProvider>
                <ReactQueryDevtools />
            </QueryClientProvider>
        );
    }

    return <div>INJECTED ACCOUNT</div>;
}

AccountApp.propTypes = {
    apolloClient: object.isRequired,
    store: object.isRequired,
    history: object.isRequired,
};

const enhance = compose(
    trackApp('mbp-account'),
);

export default enhance(AccountApp)

